export default "__VITE_ASSET__wVX5nfEh__"